/*
 * @Author: zhu.huijun
 * @Date: 2021-05-08 14:41:18
 * @Last Modified by: zhu.huijun
 * @Last Modified time: 2022-02-22 09:32:25
 */
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import {
  qryExchangeablePlanBsnl,
  qryOfferList,
  qrySalesRuleRefAttr,
  qrySubsPlanDesc,
  qrySubsPlanDetailBsnl
} from '@/services/selectPlan';
import {getRequestData} from '@/utils';

export default {
  namespace: 'selectPlan',
  state: {
    offerList: [],
    pageInfo: {}, // 套餐分页信息 套餐新需求全部改完后这个属性需要删除
    total: 0,
  },
  effects: {
    *qryOfferList({ payload }, { call, put }) {
      const response = yield call(qryOfferList, payload);
      const { offerList = [], pageInfo = {} } = getRequestData(response);
      if (payload.pageInfo.currentPage === 1) { // 只有第一页返回的总数才是真正的总数
        yield put({
          type: 'save',
          payload: {
            total: get(pageInfo, 'total') || 0,
          },
        });
      }
      yield put({ // 套餐新需求全部改完后需要删除
        type: 'save',
        payload: {
          offerList,
          pageInfo: {
            currentPage: get(pageInfo, 'currentPage'),
            pageSize: get(pageInfo, 'pageSize'),
          },
        },
      });
      return {
        offerList,
        pageDto: {
          currentPage: get(pageInfo, 'currentPage'),
          pageSize: get(pageInfo, 'pageSize'),
          total: get(pageInfo, 'total') || 0,
        },
      };
    },
    // 查询套餐详情
    *qrySubsPlanDetailBsnl({ payload, modelKey }, { call, put }) {
      const response = yield call(qrySubsPlanDetailBsnl, payload);
      const { subsPlanDetailDto = {} } = getRequestData(response);
      const comboUnitDtoList = get(subsPlanDetailDto, 'comboUnitDtoList') || [];
      const attrList = get(subsPlanDetailDto, 'subsPlanDto.attrDtoList') || [];
      const casualPlanType = attrList.find(attr => attr.attrCode === 'BSNL_CASUAL_PLAN_TYPE') || {};
      const accessTypeArrObj = attrList.find(it => it.attrCode === 'EXP_ACCESS_TYPE') || {};
      const sharedDeviceAttr = attrList.find(it => it.attrCode === 'BSNL_DEF_BEARING_4_SUBS_PLAN') || {};
      const offerInfo = {
        isCombo: !isEmpty(comboUnitDtoList), // 是否是combo业务
        isCasual: casualPlanType.defaultValue === 'CASUAL', // BSNL_CASUAL_PLAN_TYPE = CASUAL
        isPromotion: casualPlanType.defaultValue === 'PROMOTION', // BSNL_CASUAL_PLAN_TYPE = PROMOTION
        offerDetail: subsPlanDetailDto,
        offerAccessType: accessTypeArrObj.defaultValue,
        needSharedDevice: !isEmpty(sharedDeviceAttr.defaultValue), // 需要采集承载订户
      };
      if (modelKey) {
        yield put({
          type: `${modelKey}/save`,
          payload: offerInfo,
        });
      }
      return offerInfo;
    },
    // 查询默认资费计划
    *qryDppOfferList({ payload }, { call }) {
      const { addressId, subsPlanId, refAttrDtoList } = payload;
      const response = yield call(qrySubsPlanDetailBsnl, { subsPlanId, addressId, refAttrDtoList, offerGroupType: '6' });// 与套餐详情是同一个接口，入参条件offerGroupType为'6'
      const offerGroupList = get(getRequestData(response), 'subsPlanDetailDto.offerGroupDtoList') || [];
      return offerGroupList[0] ? offerGroupList[0].offerGroupMemDtoList : [];
    },
    // 查询临时套餐可切换套餐
    *qryExchangeablePlanBsnl({ payload }, { call }) {
      const response = yield call(qryExchangeablePlanBsnl, payload);
      const { availableOfferDtoList = [] } = getRequestData(response);
      return availableOfferDtoList || [];
    },
    // 查询资费描述接口
    *qrySubsPlanDesc({ payload }, { call }) {
      const response = yield call(qrySubsPlanDesc, payload);
      const { subsPlanDesc } = getRequestData(response);
      return subsPlanDesc || {};
    },

    // 获取可选scheme过滤条件
    *qrySalesRuleRefAttr({ payload }, { call }) {
      const response = yield call(qrySalesRuleRefAttr, payload);
      const { refAttrDtoList } = getRequestData(response);
      return refAttrDtoList || [];
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
